export default __webpack_public_path__ + "static/media/ck.4b0176c0.svg";